//import vuetify from 'vite-plugin-vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/assets/variables.scss'

//import { defineNuxtPlugin } from '#app'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import colors from 'vuetify/util/colors'

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: false,
    components,
    directives,
    theme: {
      //defaultTheme: 'dark',
      themes: {
        light: {
          colors: {
            'c-grey': '#f5f5f5',
            'c-grey-2': 'rgb(238, 238, 238)',
            'c-grey-3': 'rgb(248, 248, 248)',
            'c-grey-4': 'rgb(251, 251, 251)'
          }
        },
        dark: {
          //dark: true,
          colors: {
            //'c-grey': colors.grey.darken4
            'c-grey': '#2E2E2E',
            'c-grey-2': 'rgb(66,66,66)',
            'c-grey-2': 'rgb(77,77,77)',
            'c-grey-2': 'rgb(88,88,88)'
          }
        }
      }
    }
  })

  nuxtApp.vueApp.use(vuetify)
})
